import o from "react";
import { Modal as c } from "../../../../../features/common/components/Modal/Modal.js";
import { LandingButton as a } from "../../../../../features/landing/components/LandingButton/LandingButton.js";
import { useSharedLanding as i } from "../../hooks/useSharedLanding/useSharedLanding.js";
import n from "./globalModal.module.scss.js";
function b() {
  const {
    closeModal: r,
    isGlobalModalOpen: l,
    globalModal: t,
    design: e
  } = i();
  return /* @__PURE__ */ o.createElement("div", { "data-testid": "shared-landing-global-modal" }, /* @__PURE__ */ o.createElement(
    c,
    {
      design: {
        backgroundColor: e.general.highlightBackground,
        textColor: e.general.highlightText,
        fontFamily: e.font
      },
      show: l,
      onClose: () => r(),
      title: t == null ? void 0 : t.title
    },
    /* @__PURE__ */ o.createElement("div", { className: n.globalModal__content }, t == null ? void 0 : t.content, (t == null ? void 0 : t.button) && /* @__PURE__ */ o.createElement("div", { className: n.globalModal__buttons }, t.button.cancel && /* @__PURE__ */ o.createElement(
      a,
      {
        className: n.globalModal__button,
        action: t.button.cancel.action,
        textColor: e.general.secondaryButtonText,
        backgroundColor: e.general.secondaryButtonBackground
      },
      t.button.cancel.text
    ), t.button.accept && /* @__PURE__ */ o.createElement(
      a,
      {
        className: n.globalModal__button,
        action: t.button.accept.action,
        textColor: e.general.primaryButtonText,
        backgroundColor: e.general.primaryButtonBackground
      },
      t.button.accept.text
    )))
  ));
}
export {
  b as SharedLandingGlobalModal
};
//# sourceMappingURL=globalModal.js.map
